export const SUMMER_STAR_COLORS = ['#ffe66d', '#00b4d8', '#ff9e64', '#ff6b35', '#fff8e7'];

/** Right-side width reserved for camera + chat frames (640px + margins). */
export const RIGHT_OVERLAY_RESERVED_WIDTH = 667;

export const SUMMER_CONFETTI_COLORS = ['#ff6b35', '#00b4d8', '#ffe66d', '#fff8e7'];

export const SUMMER_APPEARANCE = {
  labelColor: '#ffe66d',
  valueColor: '#fff8e7',
  accentColor: '#ff9e64',
  progressBarColor: '#ff6b35',
};

export function mergeSummerConfig(config) {
  return {
    ...config,
    appearance: {
      ...config?.appearance,
      ...SUMMER_APPEARANCE,
    },
  };
}
